import ActivityCheck from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/active-check';
import Container from '@/components/container';
// 我的创建
import createData from '@/pages/activity-manage/my-create/constants/data';

export default function Check() {
  return (
    <Container bg margin={false}>
      <ActivityCheck data={createData} destory />
    </Container>
  );
}
